<template>
  <OrderPageSection is-panel>
    <OrderInfoTile :label="refundStatusString" value="" />
    <OrderDescGroup :padding-y="16" :item-gap="12">
      <OrderDescription
        type="amount"
        label="退款金额"
        :value="data.refundAmount"
      />
      <OrderDescription
        type="time"
        label="申请时间"
        :value="data.refundCreateTime"
        time-format="YYYY-MM-DD HH:mm:ss"
      />

      <OrderDescription
        v-if="data.refundStatus === 2"
        label="驳回原因"
        :value="data.approveComment"
      />
      <OrderDescription v-else label="退款原因" :value="data.refundComment" />
      <OrderDescription type="images" label="附件" :value="data.attachments" />
    </OrderDescGroup>
  </OrderPageSection>
</template>

<script>
import { getEnumMap } from "@/api";
import OrderDescGroup from "../widgets/OrderDescGroup.vue";
import OrderDescription from "../widgets/OrderDescription.vue";
import OrderInfoTile from "../widgets/OrderInfoTile.vue";
import OrderPageSection from "../widgets/OrderPageSection.vue";

export default {
  components: {
    OrderPageSection,
    OrderInfoTile,
    OrderDescGroup,
    OrderDescription,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return { refundStatusMap: {} };
  },
  mounted() {
    getEnumMap("OrderRefundStatusEnum").then((map) => {
      this.refundStatusMap = map;
    });
  },
  computed: {
    refundStatusString() {
      return this.refundStatusMap[this.data.refundStatus] || "";
    },
  },
};
</script>
